import { BodyText } from '@paypalcorp/pp-react'
import PageMessage from 'ppbl/components/PageMessage'
import { useApplicationContext } from 'ppbl/hooks'
import { merge } from 'lodash-es'
import { trackPage, trackClick } from 'ppbl/utils/fpti-helper'
import { FPTI_EVENTS } from 'ppbl/utils/fptiEventNames'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import { interpolate } from 'ppbl/utils/string-helper'
import React, { useEffect } from 'react'
import clientLogger from 'ppbl/utils/client-logger'
import {
  isRenewalFlow,
  getPortalUrl,
  getProductName,
} from 'ppbl/screens/__utils__'
import { CaseTypes } from 'ppbl/utils/constants'

const fptiData = {
  page: 'ineligiblePage',
  event_name: FPTI_EVENTS.PAGE.INELIGIBLE,
}

type Props = {
  applicationType: string
}

const IneligiblePage: React.FC<Props> = ({ applicationType }) => {
  const { data } = useApplicationContext()

  useEffect(() => {
    clientLogger.info(
      'Ineligible page is loaded - Application ID:',
      data?.applicationMetaData?.applicationId,
    )
    trackPage(
      merge(fptiData, {
        applicationId: data?.applicationMetaData?.applicationId,
      }),
    )
  }, [])

  const portalInfo = data?.applicationMetaData?.portalAccess
  const legalBusinessName = data?.applicationMetaData?.legalBusinessName
  const product = getProductName(applicationType)

  const handleContinueToPortalClick = function () {
    trackClick(
      merge(fptiData, {
        component: `continueToPortal_ineligiblePage_button`,
        link: `continueToPortal_ineligiblePage_button`,
        applicationId: data?.applicationMetaData?.applicationId,
        event_name: FPTI_EVENTS.CLICK.NAVIGATION.CONTINUE_TO_PORTAL,
      }),
    )
    const portalUrl = getPortalUrl(portalInfo, CaseTypes.DECLINED)
    window.open(portalUrl, '_self')
    sessionStorage.setItem('mostRecentCompletedPage', 'ineligible')
  }

  return (
    <PageMessage
      type="warning"
      maskTitle
      onPrimaryAction={
        isRenewalFlow(applicationType) && handleContinueToPortalClick
      }
      localization={{
        title: interpolate(getLocalizedText('ineligible-page.title'), {
          legalBusinessName,
          product,
        }),
        primaryText: getLocalizedText(`ineligible-page.continueBtn`),
      }}
    >
      <BodyText className="body__text">
        {getLocalizedText('ineligible-page.bodyText1')}
        <br />
        <br />
        {interpolate(getLocalizedText('ineligible-page.bodyText2'), {
          product,
        })}
      </BodyText>
    </PageMessage>
  )
}

export default IneligiblePage
